import { useEffect, useState } from "react";
import { listEntityRows } from "./apiClient.js";

// Master ("combined") company names for the report filter dropdowns — DATA
// since migration 010 (System Data → Owner Data → Master Companies), replacing
// the config/combinedCompanies.js constant these pages used to import.
//
// Module-level cache: the list changes when the OWNER edits it, i.e. rarely
// and never mid-session for the person filtering a report — one fetch per
// page load is the right freshness. Filter VALUES stay the names ("group:VERO"
// on the wire), so saved searches survive the storage change untouched.
let cached = null;

export function useMasterCompanyNames() {
  const [names, setNames] = useState(cached || []);
  useEffect(() => {
    if (cached) return;
    const controller = new AbortController();
    listEntityRows("master-companies", { signal: controller.signal })
      .then((rows) => {
        cached = rows.map((r) => r.name);
        setNames(cached);
      })
      // Deliberately silent, aborts included: the groups are an ENHANCEMENT
      // to the insurer dropdown, and without them it simply shows companies
      // only — no empty list, nothing broken to report.
      .catch(() => {});
    return () => controller.abort();
  }, []);
  return names;
}
